<div class="toggle-cover" matRipple [ngClass]="{'checked': checked}" (click)="onClick()">
    <div class="checked-icon">
        <ion-icon name="checkmark-sharp"></ion-icon>
    </div>
    <div class="toggle-slider"></div>
</div>
<!-- <input type="text" [(ngModel)]="value" /> -->
<!-- {{value}} -->